import FilterWrap from "components/htmlElements/FilterWrap";
import React from "react";
import Select from "react-select";
import { filterName } from "pages/ReportsPage/types";
import CustomOption from "./customOption";
import DropdownIndicator from "./dropdownIndicator";
import "./statusSelect.scss";

type SelectControlsProps = {
  options: { label: string; value: number | number[] }[];
  onChange: (
    filterName: filterName,
    selectedOption: {
      label: string;
      value: number[];
    }
  ) => void;
  label?: string;
  selectedOption: {
    label: string;
    value: number[];
  };
};

const SelectControl = ({
  options,
  onChange,
  label,
  selectedOption,
}: SelectControlsProps) => {
  const selectComponents = { DropdownIndicator, Option: CustomOption };

  const onSelectChange = (selected: { label: string; value: number[] }) => {
    onChange(filterName.reportsStatuses, selected);
  };

  return (
    <FilterWrap className="filterWrap">
      <div className="customDropdown">
        {label && (
          <label htmlFor={label} className="floating-label">
            {label}
          </label>
        )}
        <Select
          defaultValue={options[0]}
          value={selectedOption}
          options={options}
          isRtl
          isSearchable={false}
          closeMenuOnSelect
          components={selectComponents}
          className="selectControl singleSelect"
          classNamePrefix="select"
          onChange={onSelectChange}
        />
      </div>
    </FilterWrap>
  );
};

export default SelectControl;
